'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/Medal.es.js";
const o = a.forwardRef((a$2, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...a$2, weights: a$1 }));
o.displayName = "MedalIcon";
const n = o;
export {
  n as Medal,
  o as MedalIcon
};
